<template>
    <money :value="value"
           class="form-control"
           :disabled="disabled"
           @input="valueChanged($event)"
           @change="valueChanged($event)"
           :key="componentKey"
           size="lg" v-bind="money"/>
</template>

<script>
import { Money } from 'v-money'
import debounce from 'lodash/debounce';

export default {
    props: { value: null, min: Number, max: Number, disabled: Boolean },
    components: { Money },
    data() {
        return {
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' ' + this.$settings.currency.text,
                precision: 0,
                masked: false /* doesn't work with directive */
            },
            componentKey: 0, // this is necessary to rerender the money component
        }
    },
    created() {
    },
    methods: {
        forceUpdate() {
            this.componentKey = this.componentKey === 1 ? 0 : 1
        },

        valueChanged(newVal) {
            if (!this.$isEmpty(this.max) && newVal > this.max) {
                newVal = this.max
                this.forceUpdate()
            }
            if (!this.$isEmpty(this.min) && newVal < this.min) {
                newVal = this.min
                this.forceUpdate()
            }
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        }
    }
}
</script>

<style>

</style>
